import { render, staticRenderFns } from "./NavbarLogotype.vue?vue&type=template&id=044add27&scoped=true"
import script from "./NavbarLogotype.vue?vue&type=script&lang=js"
export * from "./NavbarLogotype.vue?vue&type=script&lang=js"
import style0 from "./NavbarLogotype.vue?vue&type=style&index=0&id=044add27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044add27",
  null
  
)

export default component.exports